<style scoped lang="scss" type="text/scss">
    .file-download-panel-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5rem;
        box-sizing: border-box;
        height: 2rem;
        font-size: .75rem;
        background-color: #417DFF;
        color: #FFF;
        transition: all .2s;
        border-bottom-left-radius: .15rem;

        .icon {
            margin-right: .25rem;
        }

        &:hover {
            cursor: pointer;
            transform: scale(1.1);
        }
    }
</style>

<style lang="scss" type="text/scss">
    .download-panel.check-boxes {
        width: 11rem;

        .vertical-check-item {
            margin-top: .25rem;
            width: 100%;

            &:first-of-type {
                margin-top: 0;
            }
        }
    }
</style>

<template>
    <el-button @click="download" type="primary" class="file-download-panel-container"><i class="icon">&#xe6b0;</i>导出</el-button>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
                requesting: false,
            };
        },
        methods: {
            download () {
                this.$normalRequest('player/downloadSchoolDataZip', {
                }, false, false, this, 'requesting').then(data => {
                    this.$download(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
